/**
 * sessionStorage helpers for the Venus Star Point order flow.
 * Every access is wrapped: storage can be missing or throw (private windows,
 * blocked site data), and the pages must work without it.
 */

const DRAFT_KEY = 'ivy.vsp.draft.v1';
const ORDER_KEY = 'ivy.vsp.order.v1';
const SOURCE_KEY = 'ivy.vsp.source.v1';

function read(key) {
  try {
    const raw = window.sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function write(key, value) {
  try {
    if (value == null) window.sessionStorage.removeItem(key);
    else window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // storage unavailable: the form still works, it just won't be restored
  }
}

/** Form draft (no consents, no honeypot), so a cancelled checkout returns filled in. */
export const loadDraft = () => read(DRAFT_KEY);
export const saveDraft = (draft) => write(DRAFT_KEY, draft);
export const clearDraft = () => write(DRAFT_KEY, null);

/** What the thank-you page shows: { orderId, eta, reviewMode }, set from the server's answer. */
export const loadOrderContext = () => read(ORDER_KEY);
export const saveOrderContext = (ctx) => write(ORDER_KEY, ctx);

/** First-touch marketing source for this tab. */
export function rememberSource(source) {
  if (!source) return;
  if (!read(SOURCE_KEY)) write(SOURCE_KEY, { source });
}
export const loadSource = () => read(SOURCE_KEY)?.source || null;

/** Google Ads conversion guard, so a reload of the thank-you page doesn't count twice. */
export function markConversionSent(orderId) {
  try {
    const key = `ivy.vsp.conv.${orderId}`;
    if (window.localStorage.getItem(key)) return false;
    window.localStorage.setItem(key, '1');
    return true;
  } catch (e) {
    // no storage: still send once per page view (transaction_id dedupes on Google's side)
    return true;
  }
}
